import { createTheme, darken } from '@mui/material';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true;
    sm: false;
    mobile: true;
    tablet: true;
    md: false;
    lg: true;
    xl: false;
  }
}

const defaultTheme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: '#F2F0F0',
    },
    primary: {
      main: '#386575',
    },
    text: {
      primary: darken('#9E9E9E', 0.3),
    },
    // primary: {
    //   light: '#757ce8',
    //   main: '#3f50b5',
    //   dark: '#002884',
    //   contrastText: '#fff',
    // },
    // secondary: {
    //   light: '#ff7961',
    //   main: '#f44336',
    //   dark: '#ba000d',
    //   contrastText: '#000',
    // },
  },
  typography: {
    fontFamily: 'Helvetica, sans-serif',
    h1: {
      fontSize: '2.2rem',
      fontWeight: '600',
    },
  },
  breakpoints: {
    values: {
      xs: 320,
      mobile: 480,
      tablet: 768,
      lg: 1024,
    },
  },
  portal: {
    sidebar: {
      width: '260px',
      background: '#292929',
      textColor: '#9e9e9e',
      mobileMenuAt: '600px',
    },
  },
});

// Use this to override css on global level.
// if (defaultTheme.components) {
//   defaultTheme.components.MuiAlert = {
//     styleOverrides: {
//       root: {},
//     },
//   };
// }

export default defaultTheme;
